import { Link } from "react-router-dom";

export default function Logo({ compact = false, light = false }) {
  const nameColor = light ? "text-cream-100" : "text-forest";
  const subColor = light ? "text-gold" : "text-forest-muted";
  return (
    <Link to="/" data-testid="logo-link" className="group flex items-center gap-2.5">
      <img
        src="/venya-emblem.png"
        alt="Venya"
        className="h-11 w-auto transition-transform duration-500 group-hover:scale-105"
      />
      <span className="flex flex-col leading-none">
        <span className={`font-display text-2xl font-semibold tracking-[0.12em] ${nameColor}`}>
          VENYA
        </span>
        {!compact && (
          <span
            className={`mt-1 flex w-full justify-between font-medium ${subColor}`}
            style={{ fontSize: "0.55rem", letterSpacing: "0.02em" }}
          >
            {"TRADE ENTERPRISES".split("").map((c, i) => (
              <span key={i}>{c === " " ? "\u00A0" : c}</span>
            ))}
          </span>
        )}
      </span>
    </Link>
  );
}
